import { render } from "./PagoServicioPublico.vue?vue&type=template&id=2804b547&scoped=true"
import script from "./PagoServicioPublico.vue?vue&type=script&lang=js"
export * from "./PagoServicioPublico.vue?vue&type=script&lang=js"

import "./PagoServicioPublico.vue?vue&type=style&index=0&id=2804b547&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2804b547"]])

export default __exports__